/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type CoinsPageLoggedOutQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CoinsPageLoggedOutQuery = { __typename?: 'Query', coinsPopularProducts: { __typename?: 'CoinsPopularResponse', classes?: Array<{ __typename?: 'CoinsPopularProduct', id: number, url: string, title: string, image: string }> | null, crafts?: Array<{ __typename?: 'CoinsPopularProduct', id: number, url: string, title: string, image: string }> | null } };

export type CoinsPageLoggedInQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CoinsPageLoggedInQuery = { __typename?: 'Query', coinsSettings: { __typename?: 'CoinSettings', spending?: { __typename?: 'CoinSpendingSettings', products: { __typename?: 'CoinSpendingProductsSettings', crafts: number, classes: number, bundles: number } } | null, rewards?: { __typename?: 'CoinRewardsSettings', postSocialProductProject: number, postProductReview: number, registerAccount: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null }, coinsBundles: { __typename?: 'CoinsBundlesResponse', items: Array<{ __typename?: 'CoinsBundle', id: string, url: string, title: string, image?: string | null, craftsCharacteristic?: string | null, fontCharacteristic?: string | null, graphicCharacteristic?: string | null, type: { __typename?: 'CoinsBundleType', title: string }, coins?: { __typename?: 'CoinsBundleTransactionInfo', spent?: { __typename?: 'CoinTransaction', id: string, status: Types.CoinTransactionStatus } | null } | null }> }, coins: { __typename?: 'CoinWallet', balance: number, availableRewards: { __typename?: 'CoinAvailableRewards', projectPosts?: number | null, reviews?: number | null }, transactions: { __typename?: 'CoinWalletTransactions', transactions?: Array<{ __typename?: 'CoinTransaction', id: string, type: Types.CoinTransactionType, amount: number, status: Types.CoinTransactionStatus, reason?: string | null, origin: { __typename?: 'CoinOrigin', action: Types.CoinTransactionOrigin, label?: string | null, product?: { __typename?: 'CoinProduct', title: string, url: string } | null, user?: { __typename?: 'PublicUserProfile', firstName?: string | null, lastName?: string | null, slug?: string | null } | null } }> | null } }, coinsDownloads: { __typename?: 'CoinsDownloadsResponse', items: Array<{ __typename?: 'CoinsDownload', id: string, title: string, type: string, url: string, image: string }> }, coinsPopularProducts: { __typename?: 'CoinsPopularResponse', classes?: Array<{ __typename?: 'CoinsPopularProduct', id: number, url: string, title: string, image: string }> | null, crafts?: Array<{ __typename?: 'CoinsPopularProduct', id: number, url: string, title: string, image: string }> | null } };

export type CoinsTransactionsPageQueryVariables = Types.Exact<{
  page: Types.Scalars['Int']['input'];
  pageSize: Types.Scalars['Int']['input'];
}>;


export type CoinsTransactionsPageQuery = { __typename?: 'Query', coinsTransactions: { __typename?: 'CoinTransactionsResponse', pagination?: { __typename?: 'Pagination', itemsPerPage: number, page: number, totalPages: number } | null, transactions?: Array<{ __typename?: 'CoinTransaction', id: string, type: Types.CoinTransactionType, amount: number, status: Types.CoinTransactionStatus, reason?: string | null, origin: { __typename?: 'CoinOrigin', action: Types.CoinTransactionOrigin, label?: string | null, product?: { __typename?: 'CoinProduct', title: string, url: string } | null, user?: { __typename?: 'PublicUserProfile', firstName?: string | null, lastName?: string | null, slug?: string | null } | null } }> | null } };

export type CoinsTransactionForProductIdQueryVariables = Types.Exact<{
  productId: Types.Scalars['String']['input'];
}>;


export type CoinsTransactionForProductIdQuery = { __typename?: 'Query', coinsTransactionForProductId: { __typename?: 'CoinTransactionResponse', transaction?: { __typename?: 'CoinTransaction', id: string, type: Types.CoinTransactionType, amount: number, status: Types.CoinTransactionStatus } | null, errors?: Array<{ __typename?: 'ErrorMessage', message: string }> | null } };

export type CoinsUpdateTransactionStatusMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  status: Types.CoinTransactionStatus;
}>;


export type CoinsUpdateTransactionStatusMutation = { __typename?: 'Mutation', coinsUpdateTransactionStatus: { __typename?: 'UpdateCoinTransactionStatusResponse', transaction?: { __typename?: 'CoinTransaction', id: string, status: Types.CoinTransactionStatus } | null, errors?: Array<{ __typename?: 'ErrorMessage', message: string }> | null } };

export type CoinsSpendOnProductMutationVariables = Types.Exact<{
  productId: Types.Scalars['String']['input'];
}>;


export type CoinsSpendOnProductMutation = { __typename?: 'Mutation', coinsSpendOnProduct: { __typename?: 'CoinsSpendResponse', transaction?: { __typename?: 'CoinTransaction', id: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', message: string }> | null } };


export const CoinsUpdateTransactionStatusDocument = `
mutation coinsUpdateTransactionStatus($id: String!, $status: CoinTransactionStatus!) {
  coinsUpdateTransactionStatus(id: $id, status: $status) {
    transaction {
      id
      status
    }
    errors {
      message
    }
  }
}

`

export const coinsUpdateTransactionStatusMutationKey = 'coinsUpdateTransactionStatus'

export function coinsUpdateTransactionStatusMutationFetcher(variables: CoinsUpdateTransactionStatusMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<CoinsUpdateTransactionStatusMutation, CoinsUpdateTransactionStatusMutationVariables>(CoinsUpdateTransactionStatusDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useCoinsUpdateTransactionStatusMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<CoinsUpdateTransactionStatusMutation, E, CoinsUpdateTransactionStatusMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<CoinsUpdateTransactionStatusMutation, E, CoinsUpdateTransactionStatusMutationVariables, C>({
        ...options,
        mutationKey: [coinsUpdateTransactionStatusMutationKey],
        mutationFn: (variables: CoinsUpdateTransactionStatusMutationVariables) => coinsUpdateTransactionStatusMutationFetcher(variables, fetchOptions),
    })
}

export const CoinsSpendOnProductDocument = `
mutation coinsSpendOnProduct($productId: String!) {
  coinsSpendOnProduct(productId: $productId) {
    transaction {
      id
    }
    errors {
      message
    }
  }
}

`

export const coinsSpendOnProductMutationKey = 'coinsSpendOnProduct'

export function coinsSpendOnProductMutationFetcher(variables: CoinsSpendOnProductMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<CoinsSpendOnProductMutation, CoinsSpendOnProductMutationVariables>(CoinsSpendOnProductDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useCoinsSpendOnProductMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<CoinsSpendOnProductMutation, E, CoinsSpendOnProductMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<CoinsSpendOnProductMutation, E, CoinsSpendOnProductMutationVariables, C>({
        ...options,
        mutationKey: [coinsSpendOnProductMutationKey],
        mutationFn: (variables: CoinsSpendOnProductMutationVariables) => coinsSpendOnProductMutationFetcher(variables, fetchOptions),
    })
}

export const CoinsPageLoggedOutDocument = `
query coinsPageLoggedOut {
  coinsPopularProducts {
    classes {
      id
      url
      title
      image
    }
    crafts {
      id
      url
      title
      image
    }
  }
}

`

export const coinsPageLoggedOutQueryRootKey = 'coinsPageLoggedOut'

export function coinsPageLoggedOutQueryFetcher(variables?: CoinsPageLoggedOutQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<CoinsPageLoggedOutQuery, CoinsPageLoggedOutQueryVariables>(CoinsPageLoggedOutDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function coinsPageLoggedOutQueryKey(variables?: CoinsPageLoggedOutQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [coinsPageLoggedOutQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function coinsPageLoggedOutQueryOptions(
    variables?: CoinsPageLoggedOutQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<CoinsPageLoggedOutQuery, unknown, CoinsPageLoggedOutQuery, (CoinsPageLoggedOutQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: coinsPageLoggedOutQueryKey(variables, fetchOptions),
        queryFn: coinsPageLoggedOutQueryFetcher(variables, fetchOptions),
    }
}

export function useCoinsPageLoggedOutQuery<D = CoinsPageLoggedOutQuery, E = unknown>(
    variables?: CoinsPageLoggedOutQueryVariables,
    options?: Omit<UseQueryOptions<CoinsPageLoggedOutQuery, E, D, (CoinsPageLoggedOutQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<CoinsPageLoggedOutQuery, E, D, (CoinsPageLoggedOutQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...coinsPageLoggedOutQueryOptions(variables, fetchOptions),
    })
}

export const CoinsPageLoggedInDocument = `
query coinsPageLoggedIn {
  coinsSettings {
    spending {
      products {
        crafts
        classes
        bundles
      }
    }
    rewards {
      postSocialProductProject
      postProductReview
      registerAccount
    }
    errors {
      code
      message
    }
  }
  coinsBundles {
    items {
      id
      url
      title
      image
      type {
        title
      }
      coins {
        spent {
          id
          status
        }
      }
      craftsCharacteristic
      fontCharacteristic
      graphicCharacteristic
    }
  }
  coins {
    availableRewards {
      projectPosts
      reviews
    }
    balance
    transactions(page: 1, itemsPerPage: 5) {
      transactions {
        id
        type
        amount
        status
        reason
        origin {
          action
          label
          product {
            title
            url
          }
          user {
            firstName
            lastName
            slug
          }
        }
      }
    }
  }
  coinsDownloads(limit: 5) {
    items {
      id
      title
      type
      url
      image
    }
  }
  coinsPopularProducts {
    classes {
      id
      url
      title
      image
    }
    crafts {
      id
      url
      title
      image
    }
  }
}

`

export const coinsPageLoggedInQueryRootKey = 'coinsPageLoggedIn'

export function coinsPageLoggedInQueryFetcher(variables?: CoinsPageLoggedInQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<CoinsPageLoggedInQuery, CoinsPageLoggedInQueryVariables>(CoinsPageLoggedInDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function coinsPageLoggedInQueryKey(variables?: CoinsPageLoggedInQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [coinsPageLoggedInQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function coinsPageLoggedInQueryOptions(
    variables?: CoinsPageLoggedInQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<CoinsPageLoggedInQuery, unknown, CoinsPageLoggedInQuery, (CoinsPageLoggedInQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: coinsPageLoggedInQueryKey(variables, fetchOptions),
        queryFn: coinsPageLoggedInQueryFetcher(variables, fetchOptions),
    }
}

export function useCoinsPageLoggedInQuery<D = CoinsPageLoggedInQuery, E = unknown>(
    variables?: CoinsPageLoggedInQueryVariables,
    options?: Omit<UseQueryOptions<CoinsPageLoggedInQuery, E, D, (CoinsPageLoggedInQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<CoinsPageLoggedInQuery, E, D, (CoinsPageLoggedInQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...coinsPageLoggedInQueryOptions(variables, fetchOptions),
    })
}

export const CoinsTransactionsPageDocument = `
query coinsTransactionsPage($page: Int!, $pageSize: Int!) {
  coinsTransactions(page: $page, itemsPerPage: $pageSize) {
    pagination {
      itemsPerPage
      page
      totalPages
    }
    transactions {
      id
      type
      amount
      status
      reason
      origin {
        action
        label
        product {
          title
          url
        }
        user {
          firstName
          lastName
          slug
        }
      }
    }
  }
}

`

export const coinsTransactionsPageQueryRootKey = 'coinsTransactionsPage'

export function coinsTransactionsPageQueryFetcher(variables: CoinsTransactionsPageQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<CoinsTransactionsPageQuery, CoinsTransactionsPageQueryVariables>(CoinsTransactionsPageDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function coinsTransactionsPageQueryKey(variables: CoinsTransactionsPageQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [coinsTransactionsPageQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function coinsTransactionsPageQueryOptions(
    variables: CoinsTransactionsPageQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<CoinsTransactionsPageQuery, unknown, CoinsTransactionsPageQuery, (CoinsTransactionsPageQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: coinsTransactionsPageQueryKey(variables, fetchOptions),
        queryFn: coinsTransactionsPageQueryFetcher(variables, fetchOptions),
    }
}

export function useCoinsTransactionsPageQuery<D = CoinsTransactionsPageQuery, E = unknown>(
    variables: CoinsTransactionsPageQueryVariables,
    options?: Omit<UseQueryOptions<CoinsTransactionsPageQuery, E, D, (CoinsTransactionsPageQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<CoinsTransactionsPageQuery, E, D, (CoinsTransactionsPageQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...coinsTransactionsPageQueryOptions(variables, fetchOptions),
    })
}

export const CoinsTransactionForProductIdDocument = `
query coinsTransactionForProductId($productId: String!) {
  coinsTransactionForProductId(productId: $productId) {
    transaction {
      id
      type
      amount
      status
    }
    errors {
      message
    }
  }
}

`

export const coinsTransactionForProductIdQueryRootKey = 'coinsTransactionForProductId'

export function coinsTransactionForProductIdQueryFetcher(variables: CoinsTransactionForProductIdQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<CoinsTransactionForProductIdQuery, CoinsTransactionForProductIdQueryVariables>(CoinsTransactionForProductIdDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function coinsTransactionForProductIdQueryKey(variables: CoinsTransactionForProductIdQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [coinsTransactionForProductIdQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function coinsTransactionForProductIdQueryOptions(
    variables: CoinsTransactionForProductIdQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<CoinsTransactionForProductIdQuery, unknown, CoinsTransactionForProductIdQuery, (CoinsTransactionForProductIdQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: coinsTransactionForProductIdQueryKey(variables, fetchOptions),
        queryFn: coinsTransactionForProductIdQueryFetcher(variables, fetchOptions),
    }
}

export function useCoinsTransactionForProductIdQuery<D = CoinsTransactionForProductIdQuery, E = unknown>(
    variables: CoinsTransactionForProductIdQueryVariables,
    options?: Omit<UseQueryOptions<CoinsTransactionForProductIdQuery, E, D, (CoinsTransactionForProductIdQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<CoinsTransactionForProductIdQuery, E, D, (CoinsTransactionForProductIdQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...coinsTransactionForProductIdQueryOptions(variables, fetchOptions),
    })
}